export default __webpack_public_path__ + "static/media/eyeson-logo.3089eb59.png";